//#region src/discount_level.ts
var DiscountLevel = /* @__PURE__ */ function(DiscountLevel) {
	DiscountLevel[DiscountLevel["Check"] = 0] = "Check";
	DiscountLevel[DiscountLevel["Item"] = 1] = "Item";
	return DiscountLevel;
}(DiscountLevel || {});
//#endregion
export { DiscountLevel };

//# sourceMappingURL=discount_level.js.map